export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7117.8caed875.jpg";